import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Avatar } from '@mui/material';
import { createTheme, useTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';
const ClearFormButtonHtmlRenderer = (props) => {
    const { data } = props;
    let src = data === null || data === void 0 ? void 0 : data.src;
    const pub_src = data === null || data === void 0 ? void 0 : data.pub_src;
    const label = data === null || data === void 0 ? void 0 : data.label;
    const href = data === null || data === void 0 ? void 0 : data.href;
    const size = data === null || data === void 0 ? void 0 : data.size;
    const defaultHoverTextColor = props.defaultHoverTextColor;
    const hoverTextColor = data === null || data === void 0 ? void 0 : data.hoverTextColor;
    const color = data === null || data === void 0 ? void 0 : data.color;
    const backgroundColor = data === null || data === void 0 ? void 0 : data.backgroundColor;
    const hoverBackgroundColor = data === null || data === void 0 ? void 0 : data.hoverBackgroundColor;
    const clearForm = props.clearForm;
    const alignment = (data === null || data === void 0 ? void 0 : data.alignment) ? data === null || data === void 0 ? void 0 : data.alignment : 'left';
    const use_public_storage = props.useStorageUrl ? props.useStorageUrl : false;
    if (use_public_storage && pub_src) {
        src = pub_src;
    }
    const default_theme = useTheme();
    const theme = createTheme({
        palette: {
            primary: {
                light: default_theme.palette.primary.light,
                main: backgroundColor ? backgroundColor : default_theme.palette.primary.main,
                dark: hoverBackgroundColor ? hoverBackgroundColor : default_theme.palette.primary.dark,
                contrastText: color ? color : default_theme.palette.primary.contrastText,
            }
        },
    });
    let style = {
        marginLeft: 'auto',
        '&:hover': {}
    };
    if (hoverTextColor || defaultHoverTextColor) {
        style['&:hover'] = Object.assign(Object.assign({}, style['&:hover']), { color: hoverTextColor ? hoverTextColor : defaultHoverTextColor });
    }
    return (React.createElement(Box, { display: "grid", justifyContent: alignment },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(Button, { variant: 'contained', href: href ? href : "", color: "primary", "aria-label": "open drawer", sx: style, startIcon: src ? React.createElement(Avatar, { src: src }) : undefined, size: size, onClick: clearForm },
                React.createElement(Typography, { variant: "h6", noWrap: true, component: "div" }, label)))));
};
export default ClearFormButtonHtmlRenderer;
//# sourceMappingURL=ClearFormButtonHtmlRenderer.js.map